import {BaseService} from './baseService.js';
import {Service} from './service.js';

/* 
 * Handles interaction with the feedback api
 */
export class FeedbackService extends BaseService {
	
	constructor() {	
		super();
	}
	
	async getFeedback(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}	
		var data = await this.makeGETRequest('/api/resource/feedbacktickets' + params);		
		return data;
	}	
	
	async markAsComplete(feedbackId) {	
		var result = await this.makePUTRequest('/api/resource/feedbacktickets/' + feedbackId + '/markcomplete');
		return result;
	}	

	async markAsOutstanding(feedbackId) {	
		var result = await this.makePUTRequest('/api/resource/feedbacktickets/' + feedbackId + '/markoutstanding');
		return result;
	}
	
	async deleteFeedback(feedbackId) {		
		var result = await this.makeDELETERequest('/api/resource/feedbacktickets/' + feedbackId);		
		return result;
	}
	
	async postFeedback(feedback) {
		var saved = this.makePOSTRequest('/api/resource/feedbacktickets', feedback);	
		return saved;
	}	
	
	async getFeedbackComments(feedbackId) {		
		var data = await this.makeGETRequest('/api/resource/feedbacktickets/' + feedbackId + '/comments');		
		return data;
	}
	
	async deleteFeedbackComment(feedbackId, commentId) {		
		var result = await this.makeDELETERequest('/api/resource/feedbacktickets/' + feedbackId + '/comments/' + commentId);		
		return result;
	}
	
	async saveFeedbackComment(feedbackComment, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/feedbacktickets/' + feedbackComment.feedbackId + '/comments/' + feedbackComment.commentId, feedbackComment);
		} else {
			saved = await this.makePOSTRequest('/api/resource/feedbacktickets/' + feedbackComment.feedbackId + '/comments', feedbackComment);
		}
		return saved;
	}

	exportFeedback(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/feedbacktickets/export' + params);
	}

}
